export default __webpack_public_path__ + "static/media/2.cde886f4.png";